import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }

  private alerts: Alert[] = [];
  private alertsPushedSource = new Subject<Alert[]>();
  alertsPushed$ = this.alertsPushedSource.asObservable();

  private breadcrumbs: object;
  private breadcrumbSource = new Subject<object>();
  breadcrumb$ = this.breadcrumbSource.asObservable();

  private authorizedSource = new Subject<boolean>();
  authorized$ = this.authorizedSource.asObservable();

  private filterTermSource = new Subject<string>();
  filterTerm$ = this.filterTermSource.asObservable();

  searchTerm = '';
  private searchCommand = new Subject<string>();
  searchCommand$ = this.searchCommand.asObservable();

  setBreadcrumbs(appName: string = null, appId: number = null, month: number = null, admin: boolean = false) {
    this.breadcrumbs = { appName, appId, month, admin };
    this.breadcrumbSource.next(this.breadcrumbs);
  }

  checkAuth(perm: boolean) {
    this.authorizedSource.next(perm);
  }

  emitFilterTerm(term: string) {
    this.filterTermSource.next(term);
  }

  emitSearchCommand() {
    this.searchCommand.next(this.searchTerm);
  }

  pushAlerts(alertType: string, alertMessage: string) {
    this.alerts.push({
      type: alertType,
      message: alertMessage
    });
    this.alertsPushedSource.next(this.alerts);
  }

  clearAlerts() {
    this.alerts = [];
    this.alertsPushedSource.next(this.alerts);
  }

  closeAlert(a: Alert) {
    this.alerts.splice(this.alerts.indexOf(a), 1);
  }
}

class Alert {
  type: string;
  message: string;
}
